import React, { useState, useEffect } from "react";
import {
  CircularProgress,
  Box,
  Stack,
  Button,
  Alert,
  FormControlLabel,
  Checkbox,
  Typography,
} from "@mui/material";
import useMixpanel from "../../hooks/useMixpanel";
import Helper from "../functions/Helper.js";
import useLambdaImage from "../../hooks/queries/useLambdaImage";

const imageDisplayWidth = 170;

const imageOptions = {
  thumbnail: {
    imageWidth: 400,
    phaseWidth: 340,
  },
  medium: {
    imageWidth: 1000,
    phaseWidth: 600,
  },
  large: {
    imageWidth: 2000,
    phaseWidth: 600,
  },
};

const LambdaImage = ({ data, phaseNumber, imageOption }) => {
  console.log("imageOption", imageOption);
  const { mixpanel } = useMixpanel();
  const isExpo = Helper.isExpo();

  const lambdaImageQuery = useLambdaImage({
    data,
    phaseNumber,
    imageOption,
  });

  console.log("data", lambdaImageQuery.data);

  console.log("lambdaImageQuery", lambdaImageQuery);

  if (lambdaImageQuery.isFetching) {
    return (
      <Box
        sx={{
          display: "flex",
          backgroundColor: "#f5f5f5",
          alignItems: "center",
          justifyContent: "center",
          width: 170,
          height: 170,
        }}
      >
        <Box sx={{ textAlign: "center" }}>
          <CircularProgress size={20} />
          <Box sx={{ fontSize: 12 }}>Rendering Image</Box>
        </Box>
      </Box>
    );
  } else if (lambdaImageQuery.error) {
    return (
      <Box
        sx={{
          display: "flex",
          backgroundColor: "#FFE7D9",
          alignItems: "center",
          justifyContent: "center",
          width: imageDisplayWidth,
          height: imageDisplayWidth,
          textAlign: "center",
        }}
      >
        <Alert severity="error">
          Error rendering image. {Helper.printError(lambdaImageQuery.error)}
        </Alert>
      </Box>
    );
  } else if (lambdaImageQuery.isSuccess) {
    return (
      <Box>
        <img
          alt="rendered phase"
          style={{ width: imageDisplayWidth }}
          src={lambdaImageQuery.data.imageUrl}
        />
        <Button
          onClick={() => {
            mixpanel.track("Download Image", {
              type: "PNG",
              size: 2000,
            });

            if (isExpo) {
              Helper.downloadBlob(
                lambdaImageQuery.data.imageUrl,
                "Phase " + (phaseNumber + 1) + ".png",
                "download"
              );
            }
          }}
          sx={{ fontWeight: 600 }}
          color="inherit"
          download={"Phase " + (phaseNumber + 1)}
          href={isExpo ? "#" : lambdaImageQuery.data.imageUrl}
        >
          Download Image
        </Button>
      </Box>
    );
  }
};

export default function CreateImage(props) {
  const [imageOption, setImageOption] = useState("medium");
  const [status, setStatus] = useState("INITIAL");
  useEffect(() => {
    setStatus("INITIAL");
  }, [imageOption]);

  return (
    <Box>
      <Typography sx={{ mb: 2 }} gutterBottom variant="subtitle1">
        Render png images of your play.
      </Typography>
      <Box>
        <FormControlLabel
          control={
            <Checkbox
              checked={imageOption === "thumbnail"}
              value={"thumbnail"}
              onChange={(x) => setImageOption(x.target.value)}
              name="imageOption"
            />
          }
          label="Thumbnail 400px"
        />
        <FormControlLabel
          control={
            <Checkbox
              checked={imageOption === "medium"}
              value={"medium"}
              onChange={(x) => setImageOption(x.target.value)}
              name="imageOption"
            />
          }
          label="Medium 1000px"
        />
        <FormControlLabel
          control={
            <Checkbox
              checked={imageOption === "large"}
              value={"large"}
              onChange={(x) => setImageOption(x.target.value)}
              name="imageOption"
            />
          }
          label="Large 2000px"
        />
      </Box>

      {status === "INITIAL" && (
        <Button
          sx={{ mt: 2 }}
          onClick={() => {
            setStatus("IMAGES");
          }}
          variant={"contained"}
        >
          Create Images
        </Button>
      )}
      {status === "IMAGES" && (
        <Stack
          direction="row"
          useFlexGap
          flexWrap="wrap"
          spacing={2}
          sx={{ mt: 1 }}
        >
          {props.data.phases.phases.map((phase, index) => (
            <LambdaImage
              key={index}
              data={props.data}
              phaseNumber={index}
              imageOption={imageOptions[imageOption]}
            />
          ))}
        </Stack>
      )}
    </Box>
  );
}
